import React from 'react';
import { Paper, FontIcon, FlatButton, RaisedButton } from 'material-ui';
import ContractList from './basic-contract-list/list';
import RequestList from './basic-request-list/request-list';
import injectSheet from 'react-jss';
import R from 'ramda';
import PageHeader from './page-header';


class AssetsLandingPage extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedContracts: {},
      ezLoadOfferOpen: false,
    };
  }
  fn = () => {};
  selectAContract = contractId =>
    this.setState({
      selectedContracts: {
        ...this.state.selectedContracts,
        [contractId]: !this.state.selectedContracts[contractId],
      },
    });
  toggleOffer = () => this.setState({ ezLoadOfferOpen: !this.state.ezLoadOfferOpen });
  render() {
    const {
      classes,
      loggedInSession,
      viewAs,
      rates = [],
      requestsInDLQ = [],
      downloadAllOutDated,
      downloadAllCurrent,
    } = this.props;
    const currentRates = rates.filter(obj => obj.endDate >= new Date().toISOString());
    const outdatedRates = rates.filter(obj => obj.endDate < new Date().toISOString());
    return (
      <div className={classes.container}>
        <PageHeader
          {...this.props}
          ezLoadOfferOpen={this.state.ezLoadOfferOpen}
          toggleOffer={this.toggleOffer}
        />
        {
          viewAs === 'Contractor' && (
            <div style={{ marginLeft: '24px' }}>
              <FontIcon className="tc-icon-bulb" color="#ffc800" style={{ fontSize: '24px' }} />{' '}
              Please mark the rates as accepted/rejected once you have reviewed the rates.
            </div>
          )
        }
        {viewAs === 'Contractor' && Boolean(currentRates.length) && (
          <Paper className={classes.sectionContainer}>
            <div className="flex-tc-sb">
              <div className="flex-center" style={{ marginLeft: '24px' }}>
                <h4>Current Rates</h4>
              </div>
              <RaisedButton
                label="Download All"
                secondary
                onTouchTap={downloadAllCurrent}
                style={{ marginRight: '8px' }}
              />
            </div>
            <ContractList
              list={currentRates}
              downloadRates={this.props.downloadRates}
              updateContractStatus={this.props.updateContractStatus}
            />
          </Paper>
        )}
        {viewAs === 'Contractor' && Boolean(outdatedRates.length) && (
          <Paper className={classes.sectionContainer}>
            <div className="flex-tc-sb" style={{ marginLeft: '20px' }}>
              <h4 style={{ color: 'rgba(0, 0, 0, 0.34)' }}>Prior Seasons Rates</h4>
              <FlatButton
                label="Download All"
                secondary
                onTouchTap={downloadAllOutDated}
                style={{ marginRight: '8px', border: '1px solid #00bcd4' }}
              />
            </div>
            <ContractList
              list={outdatedRates}
              downloadRates={this.props.downloadRates}
              updateContractStatus={this.props.updateContractStatus}
            />
          </Paper>
        )}
        {
          viewAs === 'Supplier' && (
            (
              <Paper className={classes.sectionContainer}>
                <RequestList
                  list={this.props.requests.map(obj => {
                    return R.merge(obj, {
                      inDLQ: requestsInDLQ.indexOf(obj._id) > -1,
                    });
                  })}
                />
              </Paper>
            )
          )
        }
        <div className={classes.footer}>
          <div className={classes.powerby}>
            powered by &nbsp;
            <img src={require('../../../www/images/tourconnect-logo.svg')} style={{ width: '120px' }} />
          </div>
          {
            viewAs === 'Contractor'
            ? `Track all rate requests · Get 100% complete rates · Automate rates into your booking system`
            : `Make your products easy to sell · Track activities on your rates · Send rates to all of your partners`
          }
          <br/>
          <br/>
          <a className={classes.terms} href="http://www.tourconnect.com/terms-of-service/" target="_blank">Terms & Conditions</a>
        </div>
      </div>
    );
  }
}
const styles = {
  container: {
    padding: '16px',
    marginBottom: '48px',
  },
  footer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  powerby: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  terms: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.54)',
    textDecoration: 'underline',
  },
  sectionContainer: {
    padding: '8px 16px',
    margin: '16px 0 32px 0',
  },
  subHeaderContainer: {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '40px',
    color: 'rgba(0, 0, 0, 0.84)',
    borderBottom: '1px solid #e0e0e0',
  },
};
export default injectSheet(styles)(AssetsLandingPage);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/page.jsx